import { IsNumber } from 'class-validator';
import { BaseDto } from './base.dto';
import { MerchantGroupDto } from './merchantGroup.dto';

export class JobTitleDto extends BaseDto {
    id: number;
    merchantGroup: MerchantGroupDto;
    @IsNumber()
    merchantGroupId: number;
    name: string;
    code: string;
    createdDate?: Date;
    modifiedDate?: Date;
    lastModifiedUserId?: number;
    version?: number;
    
}